import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-bookmark-popup',
  templateUrl: './bookmark-popup.component.html',
  styleUrls: ['./bookmark-popup.component.css']
})
export class BookmarkPopupComponent {

  message: string;

  constructor(
    public dialogRef: MatDialogRef<BookmarkPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { isBookmarked: boolean }
  ) {
    this.message = data.isBookmarked
      ? 'Saved to Watchlist!'
      : 'Removed from Watchlist!';
  }

  closePopup(): void {
    this.dialogRef.close();
  }

  goToWatchlist(): void {
    window.location.href = 'cinejoy/passholders-watchlist'; 
  }
}
